var map = {
	"./marker-black.svg": "40c1",
	"./marker-gray.svg": "2b50",
	"./marker-green.svg": "233b",
	"./marker-radius.svg": "1b12",
	"./marker-red.svg": "47d7",
	"./marker-unpublished.svg": "c528",
	"./marker-yellow.svg": "98e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5086";